export var SemanticAreaNameFragment = "\nfragment SemanticAreaNameFragment on SemanticAreaName {\n  area\n}\n";